// src/pages/Users/Produits/hooks/useProductsApps.js

import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";

import {
  sortProductsByOrder,
  countDemoLinks,
} from "../utils/productsUtils";

const PRODUCTS_API_URL =
  "https://api.monappliclub.com/api/productsapp/allproductsapp";

export default function useProductsApps() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refreshProducts = useCallback(async () => {
    setLoading(true);
    setError("");

    try {
      const { data } = await axios.get(PRODUCTS_API_URL);

      if (!Array.isArray(data)) {
        throw new Error("Réponse API invalide.");
      }

      setProducts(sortProductsByOrder(data.filter(Boolean)));
    } catch (err) {
      console.error("Erreur lors du chargement des produits :", err);
      setProducts([]);
      setError("Impossible de charger les applications pour le moment.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshProducts();
  }, [refreshProducts]);

  const stats = useMemo(() => {
    return {
      total: products.length,
      demoLinks: countDemoLinks(products),
    };
  }, [products]);

  return {
    products,
    loading,
    error,
    stats,
    refreshProducts,
  };
}